import { InstructionsSteps } from '@app/enums/_index';
import { Instructions } from '@app/models/instructions.model';
import { Factory } from './_factory';

/**
 * Create Instructions Item Factory used by application
 * Creates instances of Instructions Items.
 */
export class InstructionsItemFactory implements Factory<Instructions> {
  instructions: Instructions[] = [];

  /**
   * Call and build static Instructions Items array.
   * Do not add or remove items from this array. Used as a read-only reference.
   */
  constructor() {
    this.build();
  }

  /**
   * Build static Instructions Items array
   */
  build(): void {
    this.instructions.push(
      new Instructions(InstructionsSteps.CERTIFICATION_EXAM_STEPS, [
        `Once you enroll in an exam, a registration voucher code will be sent to you.`,
        `You can access the exam Study Guide via this course.`,
        `When you are ready to register for your exam via Webassessor, visit <a class="cursor gen-primary-link--accesible" target=_blank" rel="noopener noreferrer" href="/certification/taking-a-certification-exam">Taking a Certification Exam</a> for detailed instructions.`,
      ]),
      new Instructions(InstructionsSteps.SELF_STUDY_STEPS, [
        `Check your connectivity by running our <a class="cursor gen-primary-link--accesible" target=_blank" rel="noopener noreferrer" href="/training-support/beyond-training-pre-check">Pre-check</a>.`,
        `Log in, then click Start to access your course.`,
        `When you are ready to start practical exercises, request your Virtual Lab.`,
        `Use the eBook for Course Content, Learning Checks, and to access the Lab Book.`,
      ]),
      new Instructions(InstructionsSteps.REMOTE_ACCESS_SELF_STUDY_STEPS, [
        `Check your connectivity by running our <a class="cursor gen-primary-link--accesible" target=_blank" rel="noopener noreferrer" href="/training-support/remote-access-tests">Remote Access Tests</a>.`,
        `Log in, then click Start to access your course.`,
        `When you are ready to start practical exercises, request your Virtual Lab.`,
        `Use the eBook for Course Content, Learning Checks, and to access the Lab Book.`,
      ]),
      new Instructions(InstructionsSteps.INSTRUCTOR_LED_ENROLLED_SESSION_STEPS, [
        `The course has been added to your dashboard, and a confirmation email has been sent, including the classroom link.`,
        `You have access to your eBook immediately. Please confirm you can view it before the first day of class.`,
      ]),
      new Instructions(InstructionsSteps.SELF_STUDY_DETAILS, [
        `Education Self-study training is on-demand, allowing you access at anytime and
        anywhere. Self-study consists of the same training material as the
        Instructor-Led course. An eBook and Virtual Lab. You will get access to the
        eBook immediately on registration, then request the Virtual lab when you are
        ready to get started.`,
      ]),
      new Instructions(InstructionsSteps.REMOTE_ACCESS_SELF_STUDY_DETAILS, [
        `Education Self-Study training is on-demand learning, providing access to course
        content anytime, anywhere. Self-study materials consist of the same training
        components as the Instructor Led courses (ILTs)… an eBook and a Virtual Lab.
        Access to the eBook is granted immediately upon registering for the course. To
        start your 30-day access to the Virtual Lab, open the eBook and make the request
        from within the material when you are ready to begin.`,
      ])
    );
  }

  /**
   * Return immutable or copy of Instructions Items collection
   * @returns - a slice or copy of the static collection
   */
  getCollection(): Instructions[] {
    if (this.instructions && this.instructions.length === 0) {
      this.build();
    }
    return this.instructions.slice();
  }

  /**
   * Return immutable or copy of Instructions Items collection by Subscription
   * @param type - instructions name
   * @returns - a slice or copy of the static collection
   */
  getCollectionByInstructionName(name: string): Instructions {
    return this.getCollection().find((item: Instructions) => item.name === name);
  }
}
